export const MAGIC_LINK_COOKIE = 'magic-link-redirect'
export const MAGIC_LINK_PRIMARY_ACTION = 'RESEND_MAGIC_LINK'
